import { render, staticRenderFns } from "./PanelAddress.vue?vue&type=template&id=10d1e7ae&lang=pug"
import script from "./PanelAddress.vue?vue&type=script&lang=js"
export * from "./PanelAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports